import React from 'react'
import { ScheduleMessage } from '../../pages'
import { object, string, number, array, boolean } from 'yup';
import * as yup from 'yup';
import moment from 'moment';
import { useState } from 'react';
import { BulkSmsController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { bulkSmsStore } from '../../stores';

const ScheduleMessageContainer = ({
  closeModal,
  sendPayload,
  closeComposeSide,
  tags,
  setTags,
  btnClicked,
  showComposeSide,
  setMsgView,
  setMsgFilterItem,
}) => {
  const [showOtp, setShowOtp] = useState(false)
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState('');

  const validationSchema = () => {
    return yup.object({
      scheduleTime: yup.string().required('Schedule time is required'),
      selectedDate: string().test(function () {
        const { scheduleTime, selectedDate } = this.parent;
        return scheduleTime === "customDate" && !selectedDate
          ? this.createError({
            message: 'Input a date for your custom Date',
            path: 'selectedDate',
          })
          : true;
      }),
      selectedTime: string().test(function () {
        const { scheduleTime, selectedTime } = this.parent;
        return scheduleTime === "customDate" && !selectedTime
          ? this.createError({
            message: 'Input a time for your custom Date',
            path: 'selectedTime',
          })
          : true;
      }),
    });
  };

  const selectedMessage = bulkSmsStore.selectedMessage;

  const onSubmit = async (values) => {

    const currentDate = new Date();

    let newTime;

    if (values.scheduleTime === "10mins") {
      newTime = new Date(currentDate.getTime() + 10 * 60 * 1000);
    }

    if (values.scheduleTime === "1hr") {
      newTime = new Date(currentDate.getTime() + 60 * 60 * 1000);
    }

    if (values.scheduleTime === "10amNextDay") {
      newTime = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);
      newTime.setHours(10);
      newTime.setMinutes(0);
    }

    if (values.scheduleTime === "10amNextMonday") {
      newTime = new Date();
      newTime.setDate(currentDate.getDate() + ((1 + 7 - currentDate.getDay()) % 7));
      newTime.setHours(10);
      newTime.setMinutes(0);
    }

    if (values.scheduleTime === "customDate") {
      newTime = new Date(values.selectedDate.getTime());
      const [hh, mm] = values.selectedTime.split(':');
      newTime.setHours(hh);
      newTime.setMinutes(mm);
    }

    const year = newTime.getFullYear();
    const month = newTime.getMonth() + 1;
    const day = newTime.getDate();
    const hour = newTime.getHours();
    const minute = newTime.getMinutes();

    const scheduledDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;

    bulkSmsStore.setMessagePayload({
      ...sendPayload,
      scheduledDate: scheduledDate,
      scheduledMinute: minute,
      scheduledHour: hour,
    })

    if (btnClicked === "scheduleMessageEdit") {
      let payload = bulkSmsStore.messagePayload;

      const messageId = selectedMessage._id;

      setLoading(true);
      const { status, errorMessage } = await BulkSmsController.editSms(messageId, payload);
      if (status === constant.Success) {
        setLoading(false);
        MimaToastUtil.success({
          message: constant.Success,
        });
        closeComposeSide();
        closeModal();
        setTags([]);
        setMsgView("Scheduled Messages");
        setMsgFilterItem("SCHEDULED");


      } else {
        setLoading(false);
        return MimaToastUtil.error({
          message: errorMessage,
        });
      }

    } else {
      setShowOtp(true);
    }
  }

  const onSubmitOtp = async (otp) => {
    let payload = {
      ...bulkSmsStore.messagePayload,
      pin: otp
    }

    setLoading(true)
    const { status, errorMessage } = await BulkSmsController.scheduleSms(payload);
    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
      closeModal();
      closeComposeSide();
      setTags([])
    } else {
      setLoading(false);
      return MimaToastUtil.error({
        message: errorMessage,
      });
    }

  }

  const goBack = () => {
    if (showOtp) {
      setShowOtp(false);
      setOtp("")
    } else {
      closeModal();
    }
  }

  return (
    <ScheduleMessage
      closeModal={closeModal}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      showOtp={showOtp}
      loading={loading}
      onSubmitOtp={onSubmitOtp}
      otp={otp}
      setOtp={setOtp}
      goBack={goBack}
      btnClicked={btnClicked}
      selectedMessage={selectedMessage}
    />
  )
}


export default ScheduleMessageContainer